import { render, staticRenderFns } from "./XPayIframe.vue?vue&type=template&id=67b233cc&scoped=true"
import script from "./XPayIframe.vue?vue&type=script&lang=js"
export * from "./XPayIframe.vue?vue&type=script&lang=js"
import style0 from "./XPayIframe.vue?vue&type=style&index=0&id=67b233cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b233cc",
  null
  
)

export default component.exports